import { createRouter, createWebHistory } from 'vue-router'

import { setUnauthorizedHandler } from '@/api/http'
import { useAuthStore } from '@/stores/auth'

/**
 * ???????????????????????
 *
 * ???????????????????????????????????????????????????
 * ????????????????????????????????????????????????
 *
 * @param {string | null} role
 * @returns {string} ????????
 */
export function homePathForRole(role) {
  switch (role) {
    case 'OWNER':
      return '/owner/calendar'
    case 'STAFF':
      return '/staff/tasks'
    case 'PLATFORM_ADMIN':
      return '/admin/orgs'
    default:
      return '/login'
  }
}

/**
 * ???????
 *
 * meta ??????????
 *   requiresAuth  ????????????? true????????????????
 *                 ?????????????????? meta ???????????
 *   roles         ?????????????????????????????????????????
 *
 * meta ???????????????Vue Router 4 ???????????????????? meta
 * ????? to.meta????????????????????
 */
const routes = [
  {
    path: '/',
    redirect: () => {
      // ???????????????????????????????????????????????
      const auth = useAuthStore()
      return homePathForRole(auth.role)
    },
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { requiresAuth: false },
  },

  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/ChangePasswordView.vue'),
  },

  // ---------------------------------------------------------------------
  // ????
  // ---------------------------------------------------------------------
  {
    path: '/owner',
    component: () => import('@/layouts/OwnerLayout.vue'),
    meta: { roles: ['OWNER'] },
    children: [
      {
        path: 'calendar',
        name: 'owner-calendar',
        component: () => import('@/views/owner/CalendarView.vue'),
      },
      {
        path: 'tasks/month',
        name: 'owner-tasks-month',
        component: () => import('@/views/owner/TaskMonthView.vue'),
      },
      {
        path: 'quick-entry',
        name: 'owner-quick-entry',
        component: () => import('@/views/owner/QuickEntryView.vue'),
      },
      {
        path: 'review',
        name: 'owner-review',
        component: () => import('@/views/owner/ReviewListView.vue'),
      },
      {
        path: 'review/:id',
        name: 'owner-review-detail',
        component: () => import('@/views/owner/ReviewDetailView.vue'),
      },
      {
        path: 'review-history',
        name: 'owner-review-history',
        component: () => import('@/views/owner/ReviewHistoryView.vue'),
      },
      {
        path: 'biz',
        name: 'owner-biz',
        component: () => import('@/views/owner/BizView.vue'),
      },
      {
        path: 'biz/client-statement',
        name: 'owner-client-statement',
        component: () => import('@/views/owner/ClientStatementView.vue'),
      },
      {
        path: 'biz/client-invoice',
        name: 'owner-client-invoice',
        component: () => import('@/views/owner/InvoiceView.vue'),
      },
      {
        path: 'biz/staff-payroll',
        name: 'owner-staff-payroll',
        component: () => import('@/views/owner/StaffPayrollView.vue'),
      },
      {
        path: 'settings',
        name: 'owner-settings',
        component: () => import('@/views/owner/SettingsView.vue'),
      },
      {
        path: 'settings/sms',
        name: 'owner-sms-settings',
        component: () => import('@/views/owner/SmsSettingsView.vue'),
      },
      {
        path: 'settings/invoice',
        name: 'owner-invoice-profile',
        component: () => import('@/views/owner/InvoiceProfileView.vue'),
      },

      // ????????????????????? settings ??????????????????
      //
      // ?????? URL ???? /owner/settings/xxx??????????????????????????
      // ?????I?????????????????????????????????????????????
      // SettingsView ?????? RouterView?????? v-if ???????????????????D??
      // ?????????? URL ??????????????????????????
      {
        path: 'settings/clients',
        name: 'owner-clients',
        component: () => import('@/views/owner/ClientListView.vue'),
      },
      {
        path: 'settings/buildings',
        name: 'owner-buildings',
        component: () => import('@/views/owner/BuildingListView.vue'),
      },
      {
        path: 'settings/rooms',
        name: 'owner-rooms',
        component: () => import('@/views/owner/RoomListView.vue'),
      },
      {
        path: 'settings/staff',
        name: 'owner-staff',
        component: () => import('@/views/owner/StaffListView.vue'),
      },
      {
        path: 'settings/staff/:id',
        name: 'owner-staff-detail',
        component: () => import('@/views/owner/StaffDetailView.vue'),
      },
      {
        path: 'settings/staff/:id/room-rates',
        name: 'owner-staff-rates',
        component: () => import('@/views/owner/StaffRateView.vue'),
      },
    ],
  },

  // ---------------------------------------------------------------------
  // ?????
  // ---------------------------------------------------------------------
  {
    path: '/staff',
    component: () => import('@/layouts/StaffLayout.vue'),
    meta: { roles: ['STAFF'] },
    children: [
      {
        path: 'tasks',
        name: 'staff-tasks',
        component: () => import('@/views/staff/TaskListView.vue'),
      },
      {
        path: 'tasks/month',
        name: 'staff-tasks-month',
        component: () => import('@/views/staff/TaskMonthView.vue'),
      },
      {
        path: 'income',
        name: 'staff-income',
        component: () => import('@/views/staff/IncomeView.vue'),
      },
      {
        path: 'settings',
        name: 'staff-settings',
        component: () => import('@/views/staff/SettingsView.vue'),
      },
    ],
  },

  // ---------------------------------------------------------------------
  // ????????
  // ---------------------------------------------------------------------
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { roles: ['PLATFORM_ADMIN'] },
    children: [
      {
        path: 'orgs',
        name: 'admin-orgs',
        component: () => import('@/views/admin/OrgListView.vue'),
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('@/views/admin/SettingsView.vue'),
      },
    ],
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { requiresAuth: false },
  },
]

export const router = createRouter({
  // createWebHistory ?????? URL??/owner/calendar????????? # ?? hash ????
  // ??????????????????????????????????? index.html??
  // ????????????????? 404?????????? Vite ???????????????????? Nginx??
  history: createWebHistory(),
  routes,

  /**
   * ??????????????????????????????????????????????
   *
   * ???????????????????????????????????? 40 ?????????
   * ???????????? 40 ???????????????????????????????????
   */
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

/**
 * ????????????????????????????????????
 */
router.beforeEach((to) => {
  const auth = useAuthStore()

  // ?????????????????????????????????????????? meta??
  // ???????????????????????????????????????????????
  const requiresAuth = to.meta.requiresAuth !== false

  if (requiresAuth && !auth.isLoggedIn) {
    // ?????????????????????????????????????????
    // ???????????????????????????
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  // ????????????????????????????????????
  // ????????????????????????????????????????????
  if (to.name === 'login' && auth.isLoggedIn) {
    return homePathForRole(auth.role)
  }

  // ??????????????????????????????????????????
  // ???????????????????????????????????????????
  if (auth.isLoggedIn && auth.mustChangePassword && to.name !== 'change-password') {
    return { name: 'change-password' }
  }

  // ??????meta.roles ????????????????????? to.meta ?????
  const allowedRoles = to.meta.roles
  if (allowedRoles && auth.isLoggedIn && !allowedRoles.includes(auth.role)) {
    // ?????????????????????????????????????
    // ??????????????????????????????????N??????????????????????
    // ??????????????????????????O???????????????
    return homePathForRole(auth.role)
  }

  return true
})

/**
 * ???token ?????????????????????????
 *
 * axios ?????????? 401 ?????????????????????????????????????????
 * ???????????????????????????
 */
setUnauthorizedHandler(() => {
  const auth = useAuthStore()
  auth.logout()

  // ?????????????????????????????????????????????????
  if (router.currentRoute.value.name !== 'login') {
    router.replace({
      name: 'login',
      query: { redirect: router.currentRoute.value.fullPath },
    })
  }
})
